import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {lighten, makeStyles, withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FilterListIcon from '@material-ui/icons/FilterList';
import {bindActionCreators} from "redux";
import {loadEmailsData,
	loadEmailsDataWithFilter,
	setEmailStatusFilter,
	setEmailPlateFilter,
	setEmailEmailAddressFilter,
	setEmailEndTimeFilter,
	setEmailRecipientNameFilter,
	setEmailStartTimeFilter,
	setEmailVinFilter,
	clearAllFilters} from "../../redux/modules/email";
import {connect} from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import SearchIcon from '@material-ui/icons/Search';
import DialogContentText from "@material-ui/core/DialogContentText";
import Draggable from "react-draggable";
import Divider from "@material-ui/core/Divider";
import FindReplaceIcon from '@material-ui/icons/FindReplace';
//import {MuiPickersUtilsProvider, TimePicker} from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
//import {KeyboardDateTimePicker} from "@material-ui/pickers";

//import { TimePicker, DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TimePicker,DatePicker, DateTimePicker, KeyboardDateTimePicker ,MuiPickersUtilsProvider} from "@material-ui/pickers";

function createData(regi, status, number, name, address, vin ) {
	return { regi, status, number, name, address, vin  };
}

/*const rows = [
	createData('79M J23', '617423442300', 3.7, 67, 4.3, '617-234-2300'),
	createData('60LNT 80', '617423442300', 25.0, 51, 4.9,'617-234-2568'),
	createData('890 RTY', '6174242300', 16.0, 24, 6.0,'617-234-2309'),
	createData('234 POU', '617423442300', 6.0, 24, 4.0, '617-234-2356'),
	createData('LKJ 092', '617423440', 16.0, 49, 3.9, '617-234-2376'),
	createData('290 353', '6173442300', 3.2, 87, 6.5, '617-234-4533'),
	createData('122 LOK', '617422300', 9.0, 37, 4.3, '617-234-24533'),
	createData('J23 1RE', '617442300', 0.0, 94, 0.0, '617-234-2224'),
	createData('245 QWO', '617423442300', 26.0, 65, 7.0, '617-234-5632'),
	createData('QWO 912', '61742300', 0.2, 98, 0.0, '617-234-4626'),
	createData('MFGHY 89', '617442300', 0, 81, 2.0, '617-234-4521'),
	createData('AWSP 89', '6174237878300', 19.0, 9, 37.0, '617-234-5642'),
	createData('QWE 890', '616767442300', 18.0, 63, 4.0,'617-234-4632'),
	createData('79M J231', '617423442300', 3.7, 67, 4.3, '617-234-2300'),
	createData('60LNT 802', '617423442300', 25.0, 51, 4.9,'617-234-2568'),
	createData('890 RTY2', '6174242300', 16.0, 24, 6.0,'617-234-2309'),
	createData('234 POU2', '617423442300', 6.0, 24, 4.0, '617-234-2356'),
	createData('LKJ 0922', '617423440', 16.0, 49, 3.9, '617-234-2376'),
	createData('290 3532', '6173442300', 3.2, 87, 6.5, '617-234-4533'),
	createData('122 LOK2', '617422300', 9.0, 37, 4.3, '617-234-24533'),
	createData('J23 1RE2', '617442300', 0.0, 94, 0.0, '617-234-2224'),
	createData('245 QWO2', '617423442300', 26.0, 65, 7.0, '617-234-5632'),
	createData('QWO 9122', '61742300', 0.2, 98, 0.0, '617-234-4626'),
	createData('MFGHY 892', '617442300', 0, 81, 2.0, '617-234-4521'),
	createData('AWSP 892', '6174237878300', 19.0, 9, 37.0, '617-234-5642'),
	createData('QWE 8902', '616767442300', 18.0, 63, 4.0,'617-234-4632'),
];*/

function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getComparator(order, orderBy) {
	if(orderBy == 'submitted'){
		orderBy = 'submittedDate';
	}
	
	if(orderBy == 'completed'){
		orderBy = 'completedDate';
	}
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0){ return order;}
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

const headCells = [
	{ id: 'vehiclePlateNumber', numeric: false, disablePadding: true, label: 'Plate Number' },
	{ id: 'status', numeric: false, disablePadding: false, label: 'Status' },
	{ id: 'recipientEmailAddress', numeric: false, disablePadding: false, label: ' Email Address' },
	{ id: 'recipientName', numeric: false, disablePadding: false, label: 'Recipt Name' },
	{ id: 'recipientAddress', numeric: false, disablePadding: false, label: 'Recipt Address' },
	{ id: 'vehicleVin', numeric: false, disablePadding: false, label: 'VIN' },
	{ id: 'info', numeric: false, disablePadding: false, label: ' Car Info' },
	{ id: 'submitted', numeric: false, disablePadding: false, label: 'Submitted' },
	{ id: 'completed', numeric: false, disablePadding: false, label: 'Completed' },

];

function EnhancedTableHead(props) {
	const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};
	
	return (
		<TableHead>
		<TableRow>
		<TableCell padding="checkbox">
		{/* gettig ride of check that selects all other check boxes for now
				<Checkbox
			indeterminate={numSelected > 0 && numSelected < rowCount}
			checked={rowCount > 0 && numSelected === rowCount}
			onChange={onSelectAllClick}
			inputProps={{ 'aria-label': 'select all desserts' }}
			/> */}
	</TableCell>
	{headCells.map((headCell) => (
		<TableCell
		key={headCell.id}
		align={headCell.numeric ? 'right' : 'left'}
		padding={headCell.disablePadding ? 'none' : 'default'}
		sortDirection={orderBy === headCell.id ? order : false}
	>
	<TableSortLabel
		active={orderBy === headCell.id}
		direction={orderBy === headCell.id ? order : 'asc'}
		onClick={createSortHandler(headCell.id)}
	>
		{headCell.label}
		{orderBy === headCell.id ? (
			<span className={classes.visuallyHidden}>
		{order === 'desc' ? '' : ''}
		</span>
		) : null}
	</TableSortLabel>
	
	</TableCell>
	))}
</TableRow>
	</TableHead>
);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},
	highlight:
		theme.palette.type === 'light'
			? {
				color: theme.palette.secondary.main,
				backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			}
			: {
				color: theme.palette.text.primary,
				backgroundColor: theme.palette.secondary.dark,
			},
	title: {
		flex: '1 1 100%',
	},
}));

const sendEmails= ()=>{

}


/*EnhancedTableToolbar.propTypes = {
	numSelected: PropTypes.number.isRequired,
};*/

const useStyles = theme => ({
	root: {
		width: '100%',
	},
	paper: {
		width: '100%',
		marginBottom: theme.spacing(2),
	},
	table: {
		minWidth: 750,
	},
	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1,
	},
	rootbar: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},
	title: {
		flex: '1 1 100%',
	},
	button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		//backgroundColor:"#e2580d",
		backgroundColor:"#b1e4f2",
		color:"black",
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
	},
	highlight:
		theme.palette.type === 'light'
			? {
				color: theme.palette.secondary.main,
				backgroundColor:"#34c0eb",
			}
			: {
				color: theme.palette.text.primary,
				backgroundColor: "#8f34eb",
			},
	
	
	
});

function PaperComponent(props) {
	return (
		<Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
		<Paper {...props} />
	</Draggable>
);
}


class EmailsMainPage extends React.Component {
	
	
	state = {
		order: 'asc',
		orderBy: 'vin',
		anchorEl: null,
		selected  : [],
		page:0,
		dense:false,
		rowsPerPage: 5,
		showEmailSelectDialog:false,
		
		//ponumber:"",
		//plate:"",
		//vin:"",
		location:"",
		//color:"",
		//model:"",
		//dispatchEndTime:null,
		//dispatchStartTime:null,
		//ilterStatus:"",
		//emailaddress:"",
		//recipientname:"",
		
	};
	
	//const [open, setOpen] = React.useState(false);
	
	constructor(props) {
		super(props);
		this.handleRequestSort = this.handleRequestSort.bind(this);
		this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
		
		this.handleClick = this.handleClick.bind(this);
		
		this.handleChangePage = this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
		this.handleChangeDense = this.handleChangeDense.bind(this);
		this.renderEnhancedTableToolbar = this.renderEnhancedTableToolbar.bind(this);
		
		this.handleClickShowEmailSelectClose = this.handleClickShowEmailSelectClose.bind(this);
		this.handleClickShowEmailSelect = this.handleClickShowEmailSelect.bind(this);
		this.renderFilterCheckBoxes = this.renderFilterCheckBoxes.bind(this);
		
		this.getListOfStatusForSelection = this.getListOfStatusForSelection.bind(this);
		this.handleFilterStatusChange = this.handleFilterStatusChange.bind(this);
		this.handleDispatchEndTimeChange = this.handleDispatchEndTimeChange.bind(this);
		this.handleDispatchStartTimeChange = this.handleDispatchStartTimeChange.bind(this);
		this.handleEmailaddressChange = this.handleEmailaddressChange.bind(this);
		this.handleRecipientnameChange = this.handleRecipientnameChange.bind(this);
		
		this.handlePlatenumberChange = this.handlePlatenumberChange.bind(this);
		this.handleVinChange = this.handleVinChange.bind(this);
		this.applyFilters = this.applyFilters.bind(this);
		this.clearFilters = this.clearFilters.bind(this);
		this.handleLast24Hours = this.handleLast24Hours.bind(this);
		
		
	}//End of Constructor
	
	
	getListOfStatusForSelection() {
		//let tempArray = this.props.policeArray;
		let returnArray=[];
		
		returnArray.push(<MenuItem key={'blank'} value={""}> None </MenuItem>);
		returnArray.push(<MenuItem key={'Submitted'} value={"Submitted"}> Submitted </MenuItem>);
		returnArray.push(<MenuItem key={'Pedning'} value={"Pending"}> Pending </MenuItem>);
		returnArray.push(<MenuItem key={'Complete'} value={"Complete"}>Complete</MenuItem>);
		
		return(returnArray);
	}
	
	handleFilterStatusChange(event) {
		let { setEmailStatusFilter} = this.props;
		setEmailStatusFilter(event.target.value);
		//this.setState({filterStatus:event.target.value});
	};
	
	
	handleEmailaddressChange(event) {
		//event.preventDefault();
		let { setEmailEmailAddressFilter} = this.props;
		setEmailEmailAddressFilter(event.target.value);
		//this.setState({emailaddress:event.target.value});
	}
	
	handleRecipientnameChange(event) {
		//event.preventDefault();
		let { setEmailRecipientNameFilter} = this.props;
		setEmailRecipientNameFilter(event.target.value);
		//this.setState({recipientname:event.target.value});
	}
	
	handlePlatenumberChange(event) {
		//event.preventDefault();
		let { setEmailPlateFilter} = this.props;
		setEmailPlateFilter(event.target.value);
		
		
		//this.setState({plate:event.target.value});
	}
	handleVinChange(event) {
		//event.preventDefault();
		let { setEmailVinFilter} = this.props;
		setEmailVinFilter(event.target.value);
		//this.setState({vin:event.target.value});
	}
	handleLocationChange(event) {
		//event.preventDefault();
		
		this.setState({location:event.target.value});
	}
	handlePonumberChange(event) {
		//event.preventDefault();
		
		this.setState({ponumber:event.target.value});
	}
	
	handleDispatchStartTimeChange(event) {
		let { setEmailStartTimeFilter } = this.props;
		setEmailStartTimeFilter(event);
		//this.setState({dispatchStartTime:event});
	}
	
	
	handleDispatchEndTimeChange(event) {
		let { setEmailEndTimeFilter } = this.props;
		setEmailEndTimeFilter(event);
		
		//this.setState({dispatchEndTime:event});
	}
	/*handleColorChange(event) {
		//event.preventDefault();
		
		this.setState({color:event.target.value});
	}
	handleYearChange(event) {
		//event.preventDefault();
		
		this.setState({year:event.target.value});
	}*/
	
	renderEnhancedTableToolbar(numSelected){
		const {classes} = this.props;
		//const { numSelected } = props;
		let tempImageSource = "/static/images/faxicon2.png";
		
		return (
			<Toolbar
		className={clsx(classes.rootbar, {
			[classes.highlight]: numSelected > 0,
		})}
	>
		{numSelected > 0 ? (
			<Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
			{numSelected} selected
		</Typography>
		) : (
		<Typography className={classes.title} variant="h6" id="tableTitle" component="div">
			Emails
			</Typography>
		)}
		
		
		
		
		{numSelected > 0 ? (
			
			<Grid container>
			<Grid item xs={6} sm={6}>
			</Grid>
			<Grid item xs={3} sm={3}>
			<Tooltip title="Send Email">
			<IconButton aria-label="Email">
			<MailOutlineIcon fontSize="large" />
			</IconButton>
		</Tooltip>
			</Grid>
			<Grid item xs={3} sm={3}>
			<Tooltip title="Cancel">
			<IconButton aria-label="cancel">
			<CancelOutlinedIcon fontSize="large" />
			</IconButton>
			</Tooltip>
			</Grid>
			</Grid>
			
		) : (
		<Grid container >
		<Grid item xs={6} sm={6}>
			
			</Grid>
			
			<Grid item xs={2} sm={2}>
			<Tooltip title="Filter list">
			<IconButton aria-label="filter list"    onClick={()=>this.handleClickShowEmailSelect()}>
			{(!((this.props.emailVinFilter.length != 0) ||
				(this.props.emailEmailAddressFilter.length != 0) ||
				(this.props.emailRecipientNameFilter.length != 0) ||
				(this.props.emailPlateFilter.length != 0) ||
				(this.props.emailStartTimeFilter!= null)||
				(this.props.emailStatusFilter.length!= 0)||
				(this.props.emailEndTimeFilter!= null) ))&&(<SearchIcon fontSize="large" />)}
			{(((this.props.emailVinFilter.length != 0) ||
				(this.props.emailEmailAddressFilter.length != 0) ||
				(this.props.emailRecipientNameFilter.length != 0) ||
				(this.props.emailPlateFilter.length != 0) ||
				(this.props.emailStartTimeFilter!= null)||
				(this.props.emailStatusFilter.length!= 0)||
				(this.props.emailEndTimeFilter!= null) ))&&(<FindReplaceIcon fontSize="large" />)}
			</IconButton>
			</Tooltip>
			</Grid>
			<Grid item xs={4} sm={4}>
			<Typography variant="h6" gutterBottom>
		There are {this.props.emailsArray.length}  emails in list.
		</Typography>
		</Grid>
		</Grid>
		)}
	</Toolbar>
	);
	};
	
	handleRequestSort(event, property){
		const isAsc = this.state.orderBy === property && this.state.order === 'asc';
		if(isAsc == true){
			this.setState({order: 'desc' });
		}else{
			this.setState({order: 'asc' });
		}
		
		this.setState({orderBy:property});
	};
	
	handleSelectAllClick(event){
		if (event.target.checked) {
			const newSelecteds = this.props.emailsArray.map((n) => n.vehiclePlateNumber);
			this.setState({selected:newSelecteds});
			return;
		}
		this.setState({selected:[]});
		
	};
	renderFilterCheckBoxes(){
		const {classes} = this.props;
		this.statusSelectList = this.getListOfStatusForSelection();
		
		return(
			<div>
			<Grid container >
		
		<Grid item xs={12} sm={12}>
			<Divider className={classes.dividerColor}></Divider>
			</Grid>
			<Grid item xs={6} sm={6}>
			<TextField id="plate" name="plate" label="Plate Number" fullWidth InputLabelProps={{ shrink: true }}   value={this.props.emailPlateFilter} onChange={this.handlePlatenumberChange}  />
		</Grid>
		<Grid item xs={6} sm={6}>
			<TextField id="vin" name="vin" label="VIN" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.emailVinFilter} onChange={this.handleVinChange}    />
		</Grid>
		{/*
		<Grid item xs={6} sm={6}>
		<TextField id="status" name="status" label="Status" fullWidth InputLabelProps={{ shrink: true }}  value={1}   />
		</Grid>*/}
		<Grid item xs={6} sm={6}>
		<TextField id="email" name="email" label="Email Address" fullWidth InputLabelProps={{ shrink: true }} value={this.props.emailEmailAddressFilter} onChange={this.handleEmailaddressChange}    />
		</Grid>
		<Grid item xs={6} sm={6}>
		<TextField id="recipname" name="recipname" label="Recipient Name" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.emailRecipientNameFilter} onChange={this.handleRecipientnameChange}    />
		</Grid>
		
		
		<Grid item xs={6} sm={6}>
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDateTimePicker
					value={this.props.emailStartTimeFilter}
					onChange={this.handleDispatchStartTimeChange}
					label="Start Date"
					
					format="yyyy/MM/dd hh:mm a"
				/>
			</MuiPickersUtilsProvider>
			{/*
			<Typography variant="body2" >Start Time</Typography>
			<DatePicker
		selected={this.state.dispatchStartTime}
		onChange={date => this.handleDispatchStartTimeChange(date)}
		showTimeSelect
		timeIntervals={15}
		timeCaption="time"
		dateFormat="MMMM d, yyyy h:mm aa"
			/> */}
			{/*
			<MuiPickersUtilsProvider  utils={DateFnsUtils} >
			<TimePicker
		margin="normal"
		id="time-picker"
		label="Dispatch Start Time"
		value={this.state.dispatchStartTime}
		onChange={this.handleDispatchStartTimeChange}
		KeyboardButtonProps={{
			'aria-label': 'change time',
		}}
		
		/>
		</MuiPickersUtilsProvider>
		*/}
		</Grid>
		
		<Grid item xs={6} sm={6}>
			
			
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDateTimePicker
					value={this.props.emailEndTimeFilter}
					onChange={this.handleDispatchEndTimeChange}
					label="End Date"
					
					format="yyyy/MM/dd hh:mm a"
				/>
			</MuiPickersUtilsProvider>
			{/*
			<Typography variant="body2" >End Date</Typography>
			<DatePicker
			selected={this.state.dispatchEndTime}
			onChange={date => this.handleDispatchEndTimeChange(date)}
			showTimeSelect
			timeIntervals={15}
			timeCaption="time"
			dateFormat="MMMM d, yyyy h:mm aa"
				/> */}
			{/*
			<MuiPickersUtilsProvider  utils={DateFnsUtils} >
			<TimePicker
		margin="normal"
		id="time-picker"
		label="Dispatch End Time"
		value={this.state.dispatchEndTime}
		onChange={this.handleDispatchEndTimeChange}
		KeyboardButtonProps={{
			'aria-label': 'change time',
		}}
		
		/>
		</MuiPickersUtilsProvider>*/}
		</Grid>
		<Grid item xs={6} sm={6}>
			<FormControl className={classes.formControl}>
			<InputLabel htmlFor="age-helper">Status</InputLabel>
			<Select
				value={this.props.emailStatusFilter}
				onChange={this.handleFilterStatusChange}
				inputProps={{
					name: 'status',
						id: 'status-helper',
				}}
			>
				
				{this.statusSelectList}
			
			</Select>
				{/* <FormHelperText>Select a Company </FormHelperText>  */}
			</FormControl>
		
		</Grid>
		<Grid item xs={6} sm={6}>
			<Button variant="contained" color="primary" className={classes.button}   onClick={(event) => this.handleLast24Hours(event)} >
		Last 24 Hours
		</Button>
		</Grid>
		
		
		</Grid>
		</div>
	)
	
	
	
	}
	
	
	clearFilters(){
		let { clearAllFilters } = this.props;
		clearAllFilters();
		 /*this.setState({vin:"", emailaddress:"", recipientname:"", plate:"", dispatchStartTime:null,
			 filterStatus:"", dispatchEndTime:null });
		this.setState({vin:""});*/
	}
	
	
	applyFilters(argSelectedCompany) {
		let { loadEmailsDataWithFilter } = this.props;
		let filter="";
		if((this.props.emailVinFilter.length != 0) ||
			(this.props.emailEmailAddressFilter.length != 0) ||
			(this.props.emailRecipientNameFilter.length != 0) ||
			(this.props.emailPlateFilter.length != 0) ||
			(this.props.emailStartTimeFilter!= 0)||
			(this.props.emailStatusFilter.length!= 0)||
			(this.props.emailEndTimeFilter!= 0) ) {
			filter="?";
		}
		
		if((this.props.emailVinFilter.length != 0)   ) {
			filter=filter+"vehiclevin="+this.props.emailVinFilter+"&";
		}
		
		if((this.props.emailEmailAddressFilter.length != 0)   ) {
			filter=filter+"recipientemailaddress="+this.props.emailEmailAddressFilter+"&";
		}
		
		if((this.props.emailRecipientNameFilter.length != 0)   ) {
			filter=filter+"recipientname="+this.props.emailRecipientNameFilter+"&";
		}
		
		if((this.props.emailPlateFilter.length != 0)   ) {
			filter=filter+"vehicleplatenumber="+this.props.emailPlateFilter+"&";
		}
		
		if((this.props.emailStatusFilter.length != 0)   ) {
			filter=filter+"status="+this.props.emailStatusFilter+"&";
		}
		
		if((this.props.emailEndTimeFilter != null)   ) {
			var jsonEndTime = JSON.stringify(this.props.emailEndTimeFilter);
			filter=filter+"endtime="+jsonEndTime+"&";
		}
		
		if((this.props.emailStartTimeFilter != null)   ) {
			var jsonStartTime = JSON.stringify(this.props.emailStartTimeFilter);
			filter=filter+"starttime="+ jsonStartTime+"&";
			//filter=filter+"starttime="+ this.state.dispatchStartTime+"&";
		}
		//let filter= "?vehicleyear=2007&";
		loadEmailsDataWithFilter(DEFAULT_VESPAAN_SERVER.url ,argSelectedCompany, filter);
		//loadTowjobsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere,filter  );
		this.handleClickShowEmailSelectClose(false);
		
	}
	
	handleLast24Hours () {
		let { setEmailEndTimeFilter,setEmailStartTimeFilter } = this.props;
		var currentDate = new Date();
		var yesterday= currentDate.getTime()-(24*60*60*1000);
		var yesterdayDate = new Date(yesterday);
		setEmailEndTimeFilter(currentDate);
		setEmailStartTimeFilter(yesterdayDate);
		
	}
	
	
	handleClick(event, name){
		const selectedIndex = this.state.selected.indexOf(name);
		let newSelected = [];
		
		if (selectedIndex === -1) {
			newSelected = newSelected.concat(this.state.selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(this.state.selected.slice(1));
		} else if (selectedIndex === this.state.selected.length - 1) {
			newSelected = newSelected.concat(this.state.selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				this.state.selected.slice(0, selectedIndex),
				this.state.selected.slice(selectedIndex + 1),
			);
		}
		this.setState({selected:newSelected});
		//setSelected(newSelected);
	};
	
	handleChangePage(event, newPage){
		this.setState({page:newPage});
		//setPage(newPage);
	};
	
	handleChangeRowsPerPage(event){
		//setRowsPerPage(parseInt(event.target.value, 10));
		this.setState({rowsPerPage:parseInt(event.target.value, 10)});
		this.setState({page:0});
		//setPage(0);
	};
	
	handleChangeDense(event){
		//setDense(event.target.checked);
		this.setState({dense:event.target.checked});
	};
	
	handleClickShowEmailSelectClose(argKeepDefaultWaiting) {
		let { setEmailStatusFilter } = this.props;
		if(argKeepDefaultWaiting == true) {
			setEmailStatusFilter("Pending");
		}else {
		
		}
		this.setState({showEmailSelectDialog:false});
	};
	
	handleClickShowEmailSelect() {
		
		this.setState({showEmailSelectDialog:true});
		
	};
	
	render(){
		const {classes} = this.props;
		let rows = this.props.emailsArray;
		
		const isSelected = (name) => this.state.selected.indexOf(name) !== -1;
		
		const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, rows.length - this.state.page * this.state.rowsPerPage);
		let tooBar = this.renderEnhancedTableToolbar(this.state.selected.length);
		let filterBoxes =  this.renderFilterCheckBoxes();
		
		return (
			<div className={classes.root}>
			<Paper className={classes.paper}>
			{tooBar}
			<TableContainer>
			<Table stickyHeader
		className={classes.table}
		aria-labelledby="tableTitle"
		size={this.state.dense ? 'small' : 'medium'}
		aria-label="enhanced table"
			>
			<EnhancedTableHead
		classes={classes}
		numSelected={this.state.selected.length}
		order={this.state.order}
		orderBy={this.state.orderBy}
		onSelectAllClick={this.handleSelectAllClick}
		onRequestSort={this.handleRequestSort}
		rowCount={rows.length}
		/>
		<TableBody>
		{stableSort(rows, getComparator(this.state.order, this.state.orderBy))
	.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
			.map((row, index) => {
				//const isItemSelected = isSelected(row.vehiclePlateNumber);
				const isItemSelected = isSelected(row.vehiclePlateNumber+row.recipientEmailAddress);
				const labelId = `enhanced-table-checkbox-${index}`;
				var sumittedDateStr = new Date(row.submittedDate)  ;
				sumittedDateStr= sumittedDateStr.toLocaleDateString() +" "+ sumittedDateStr.toLocaleTimeString();
				if(row.submittedDate != null) {
					/*
					var hour = sumittedDateStr.getHours() % 12;
					var newformat = sumittedDateStr.getHours() >= 12 ? 'PM' : 'AM';
					var minuteStr = sumittedDateStr.getMinutes() <= 9 ? "0" + sumittedDateStr.getMinutes() : sumittedDateStr.getMinutes();
					sumittedDateStr = sumittedDateStr.getMonth() + "/" + sumittedDateStr.getDay() + "/" + sumittedDateStr.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
					*/
				}else{
					sumittedDateStr ="---"
				}
				
				var completedDateStr = new Date(row.completedDate)  ;
				completedDateStr= completedDateStr.toLocaleDateString() +" "+ completedDateStr.toLocaleTimeString();
				if(row.completedDate != null) {
					/*var hour = completedDateStr.getHours() % 12;
					var newformat = completedDateStr.getHours() >= 12 ? 'PM' : 'AM';
					var minuteStr = completedDateStr.getMinutes() <= 9 ? "0" + completedDateStr.getMinutes() : completedDateStr.getMinutes();
					completedDateStr = completedDateStr.getMonth() + "/" + completedDateStr.getDay() + "/" + completedDateStr.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
					*/
				}else{
					completedDateStr ="---"
				}
				row.info = row.color+"-"+row.make+"-"+row.model;
				row.submitted = sumittedDateStr;
				row.completed= completedDateStr;
				return (
					<TableRow
				hover
				onClick={(event) => this.handleClick(event, row.vehiclePlateNumber+row.recipientEmailAddress)}
				role="checkbox"
				aria-checked={isItemSelected}
				tabIndex={-1}
				key={index}
				selected={isItemSelected}
					>
					<TableCell padding="checkbox">
					<Checkbox
				checked={isItemSelected}
				inputProps={{ 'aria-labelledby': labelId }}
				/>
				</TableCell>
				<TableCell component="th" id={labelId} scope="row" padding="none">
					{row.vehiclePlateNumber}  {row.vehicleState}
			</TableCell>
				<TableCell align="left">{row.status}</TableCell>
					<TableCell align="left">{row.recipientEmailAddress}</TableCell>
					<TableCell align="left">{row.recipientName}</TableCell>
					<TableCell align="left">{row.recipientAddress}</TableCell>
					<TableCell align="left">{row.vehicleVin}</TableCell>
					<TableCell align="left">{row.color}-{row.make}-{row.model}</TableCell>
					<TableCell align="left">{sumittedDateStr}</TableCell>
					<TableCell align="left">{completedDateStr}</TableCell>
					</TableRow>
			);
			})}
		{emptyRows > 0 && (
		<TableRow style={{ height: (this.state.dense ? 33 : 53) * emptyRows }}>
		<TableCell colSpan={6} />
		</TableRow>
		)}
	</TableBody>
		</Table>
		</TableContainer>
		<TablePagination
		rowsPerPageOptions={[5, 10, 25]}
		component="div"
		count={rows.length}
		rowsPerPage={this.state.rowsPerPage}
		page={this.state.page}
		onChangePage={this.handleChangePage}
		onChangeRowsPerPage={this.handleChangeRowsPerPage}
		/>
		</Paper>
		<FormControlLabel
		control={<Switch checked={this.state.dense} onChange={this.handleChangeDense} />}
		label="Dense padding"
			/>
			
			
			{/*	<Dialog
		open={this.state.showEmailSelectDialog}
		onClose={this.handleClickShowEmailSelectClose}
		scroll={'paper'}
		classes={{
			paper: classes.formControl2,
		}}
		aria-labelledby="scroll-dialog-title"
		aria-describedby="scroll-dialog-description"
		maxWidth="xl"
			>
			<DialogTitle id="scroll-dialog-title">Filter  Selection</DialogTitle>
		<DialogContent  id="farshids"   dividers="paper">
			
			<div>
			Please select the filters
		</div>
		{filterBoxes}
	</DialogContent>
		<DialogActions>
		<Tooltip title="Filters for the columns">
			<Button  color="primary" onClick={this.sendEmail}>Apply Filters</Button>
		</Tooltip>
		
		<Button onClick={this.handleClickShowEmailSelectClose} color="secondary">Cancel</Button>
			</DialogActions>
			</Dialog>  */}
			
			
			
			<Dialog
		open={this.state.showEmailSelectDialog}
		onClose={()=>{this.handleClickShowEmailSelectClose(true)}}
		PaperComponent={PaperComponent}
		aria-labelledby="draggable-dialog-title"
			>
			<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
			Email Filters
		</DialogTitle>
		<DialogContent>
		{/*
		<DialogContentText>
		Please select the filters
		</DialogContentText>*/}
		{filterBoxes}
	</DialogContent>
		<DialogActions>
		
		
		
		<Button onClick={()=> {this.applyFilters(this.props.selectedCompany)}} color="primary">
			Apply Filters
		</Button>
		<Button onClick={this.clearFilters} color="secondary">
			Clear filters
		</Button>
		<Button autoFocus onClick={()=>{this.handleClickShowEmailSelectClose(true)}} color="secondary">
			Cancel
			</Button>
			</DialogActions>
			</Dialog>
			
			
			
			</div>
	
	
	
	);
	}//end of render
	
	
	
	
	componentWillReceiveProps(nextProps) {
		let { loadEmailsData } = this.props;
		
		if (this.props.selectedCompany !== nextProps.selectedCompany) {
		
		//loadEmailsData(DEFAULT_VESPAAN_SERVER.url ,nextProps.selectedCompany);
			this.applyFilters(nextProps.selectedCompany);
		/*this.setState({
			selectedCompanyInHere: nextProps.selectedCompany
		});*/
		}
		
	}
	
	
	componentWillMount(){
		let {loadEmailsData, loadSingleUserData, loadUsersData, loadVehiclesData ,loadPoliceData, loadLocationsData,loadCompanysData, loadPdfFile  } = this.props;
		
		
		//loadUsersData(DEFAULT_VESPAAN_SERVER.url );
		//loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
		//loadEmailsData(DEFAULT_VESPAAN_SERVER.url ,this.props.selectedCompany);
		
		this.applyFilters(this.props.selectedCompany);
		this.setState({ errorCMsg:{} });
		
		
		
	}
	
	
	
	
}//end of class
EmailsMainPage.propTypes = {
	classes: PropTypes.object.isRequired,
};



const mapStateToProps = (state) => {
	return {
		emailsArray: state.email.emailsArray,
		selectedCompany:state.company.selectedCompany,
		emailStatusFilter:state.email.emailStatusFilter,
		emailEmailAddressFilter:state.email.emailEmailAddressFilter,
		emailVinFilter:state.email.emailVinFilter,
		emailPlateFilter:state.email.emailPlateFilter,
		emailRecipientNameFilter:state.email.emailRecipientNameFilter,
		emailStartTimeFilter:state.email.emailStartTimeFilter,
		emailEndTimeFilter:state.email.emailEndTimeFilter,
		
		errorCMsg:state.companyproperty.errorCMsg,
	};
};


const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		loadEmailsData:loadEmailsData,
		loadEmailsDataWithFilter:loadEmailsDataWithFilter,
		setEmailStatusFilter:setEmailStatusFilter,
		setEmailPlateFilter:setEmailPlateFilter,
		setEmailEmailAddressFilter:setEmailEmailAddressFilter,
		setEmailEndTimeFilter:setEmailEndTimeFilter,
		setEmailRecipientNameFilter:setEmailRecipientNameFilter,
		setEmailStartTimeFilter:setEmailStartTimeFilter,
		setEmailVinFilter:setEmailVinFilter,
		clearAllFilters:clearAllFilters,
		
		
	}, dispatch);
};

//export default (withStyles(useStyles)(TowInfo));
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(EmailsMainPage));

